import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetInit } from "./hooks/api/init/use-get-init.hook";

import { Routes, useNavigate } from "react-router-dom";

import axiosBaseConfig from "./configs/axios/axios-base.config";

import routeWrapper from "./router/route-wrapper";
import routes from "./router/app-routes";
import { SplashScreen } from "./components/splash-screen/splash-screen.component";
import { setInitData } from "./redux/global/global.slice";
import { setUserDetails } from "./redux/auth/auth.slice";
import { useBackHandler } from "./hooks/use-back-handler.hook";

import { safeJsonParser } from "./utilities/api/safe-json-parser.utility";
// import "./assets/libs/external-styles/react/libs/react-select/_react-select.scss";

function App() {
	const initQueryInfo = useGetInit();

	const dispatch = useDispatch();

	useBackHandler();

	const initData = useSelector((state) => state.globalData?.initData);
	const userToken = useSelector((state) => state.currentUser?.token);

	const navigate = useNavigate();
	const [isUserDataLoading, setIsUserDataLoading] = useState(false);

	useEffect(() => {
		if (initQueryInfo.data) {
			dispatch(setInitData(initQueryInfo.data));
		}
	}, [initQueryInfo.data, dispatch]);

	useEffect(() => {
		const prevVersionToken = localStorage.getItem("token");

		if (prevVersionToken) {
			setIsUserDataLoading(true);
			axiosBaseConfig
				.get("shared/userDetail")
				.then((res) => {
					const userDetails = res.data?.[0];
					const unratedRequestId =
						Number.isFinite(userDetails?.uncompleteRequestId) && userDetails?.uncompleteRequestId !== 0
							? userDetails?.uncompleteRequestId
							: undefined;

					dispatch(
						setUserDetails({
							token: prevVersionToken,
							id: userDetails.id,
							intentData: safeJsonParser(userDetails.intentData),
							phoneNumber: userDetails.userName,
							firstName: userDetails.name,
							lastName: userDetails.family,
							province: {
								id: userDetails.provinceId,
								name: userDetails.provinceName,
							},
							city: {
								id: userDetails.cityId,
								name: userDetails.cityName,
							},
							location: userDetails.location,
							lastCollectedRequest: userDetails?.fastRequest,
							membershipType: {
								id: userDetails.roleId,
								name: userDetails.roleName,
							},
							shaba: userDetails.shaba,
							score: userDetails.score,
							//ar-todo: profile-image and birthdate unknown keys in api
							profileImage: null,
							birthDate: userDetails.birthdate,
							familyMembersNumber: userDetails.familyCount,
							unratedRequestId,
							invitationText: userDetails.inviteFriend,
							scoreThreshold: userDetails.scoreThreshold,
							minAutoPayAmount: userDetails.minAutoPayAmount,
							inviteFriendScore: userDetails.inviteFriendScore,
						})
					);

					localStorage.removeItem("token");

					if (unratedRequestId !== undefined) {
						navigate("/collecting-request-score");
					}
				})
				.catch((err) => {})
				.finally(() => {
					setIsUserDataLoading(false);
				});
		} else if (userToken) {
			setIsUserDataLoading(true);
			axiosBaseConfig
				.get("shared/userDetail")
				.then((res) => {
					const userDetails = res.data?.[0];
					const unratedRequestId =
						Number.isFinite(userDetails?.uncompleteRequestId) && userDetails?.uncompleteRequestId !== 0
							? userDetails?.uncompleteRequestId
							: undefined;
					dispatch(
						setUserDetails({
							id: userDetails.id,
							intentData: safeJsonParser(userDetails.intentData),
							phoneNumber: userDetails.userName,
							firstName: userDetails.name,
							lastName: userDetails.family,
							province: {
								id: userDetails.provinceId,
								name: userDetails.provinceName,
							},
							city: {
								id: userDetails.cityId,
								name: userDetails.cityName,
							},
							location: userDetails.location,
							lastCollectedRequest: userDetails?.fastRequest,
							membershipType: {
								id: userDetails.roleId,
								name: userDetails.roleName,
							},
							shaba: userDetails.shaba,
							score: userDetails.score,
							//ar-todo: profile-image and birthdate unknown keys in api
							profileImage: null,
							birthDate: userDetails.birthdate,
							familyMembersNumber: userDetails.familyCount,
							unratedRequestId,
							invitationText: userDetails.inviteFriend,
							scoreThreshold: userDetails.scoreThreshold,
							minAutoPayAmount: userDetails.minAutoPayAmount,
							inviteFriendScore: userDetails.inviteFriendScore,
						})
					);

					if (unratedRequestId !== undefined) {
						navigate("/collecting-request-score");
					}
				})
				.catch((err) => {})
				.finally(() => {
					setIsUserDataLoading(false);
				});
		}
	}, [dispatch]);

	const isInitDataReady = !isUserDataLoading && !!initData;

	return isInitDataReady ? (
		<>
			<Routes>{routes.AppRoutes.map((route) => routeWrapper(route))}</Routes>
		</>
	) : (
		<SplashScreen />
	);
}

export default App;
